// extracted by mini-css-extract-plugin
export var card = "gridWithTooltip-module--card--zn0KH";
export var card1 = "gridWithTooltip-module--card1--zH9Lf";
export var card2 = "gridWithTooltip-module--card2--ZPFUW";
export var card3 = "gridWithTooltip-module--card3--ACLTg";
export var card4 = "gridWithTooltip-module--card4--7K-t8";
export var grid = "gridWithTooltip-module--grid--bjr5n";
export var headDescr = "gridWithTooltip-module--headDescr--zj6lE";
export var headTitle = "gridWithTooltip-module--headTitle--pxS0B";
export var iconClose = "gridWithTooltip-module--iconClose--ZqPom";
export var iconQuestion = "gridWithTooltip-module--iconQuestion--NbRDa";
export var img = "gridWithTooltip-module--img--rnXSL";
export var section = "gridWithTooltip-module--section--do26A";
export var title = "gridWithTooltip-module--title--bhUcf";
export var tooltipContent = "gridWithTooltip-module--tooltipContent--llzUr";
export var tooltipText = "gridWithTooltip-module--tooltipText--wok46";
export var zhkh = "gridWithTooltip-module--zhkh--xRiUh";